var map = {
	"./default-ca-ES.json": 1088,
	"./default-de-DE.json": 8238,
	"./default-en-GB.json": 8140,
	"./default-es-ES.json": 1368,
	"./default-fr-FR.json": 9108,
	"./default-it-IT.json": 3646,
	"./default-nl-NL.json": 9132,
	"./default-pt-PT.json": 584,
	"./en-CA.json": 4193,
	"./en-US.json": 6545,
	"./fi-FI.json": 1966,
	"./fr-BE.json": 322,
	"./fr-CA.json": 2488,
	"./fr-CH.json": 6931,
	"./nl-BE.json": 1495,
	"lib/locales/default-ca-ES.json": 1088,
	"lib/locales/default-de-DE.json": 8238,
	"lib/locales/default-en-GB.json": 8140,
	"lib/locales/default-es-ES.json": 1368,
	"lib/locales/default-fr-FR.json": 9108,
	"lib/locales/default-it-IT.json": 3646,
	"lib/locales/default-nl-NL.json": 9132,
	"lib/locales/default-pt-PT.json": 584,
	"lib/locales/en-CA.json": 4193,
	"lib/locales/en-US.json": 6545,
	"lib/locales/fi-FI.json": 1966,
	"lib/locales/fr-BE.json": 322,
	"lib/locales/fr-CA.json": 2488,
	"lib/locales/fr-CH.json": 6931,
	"lib/locales/nl-BE.json": 1495
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8809;